import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { StatePanel } from './StatePanel';

export type EmptyStateProps = {
  title: string;
  hint?: string;
  Icon?: typeof InboxOutlinedIcon;
  action?: ReactNode;
};

export const EmptyState = ({ title, hint, Icon = InboxOutlinedIcon, action }: EmptyStateProps) => (
  <StatePanel testId="empty-state">
    <Icon sx={{ fontSize: 40, color: 'text.secondary' }} />
    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.primary' }}>
      {title}
    </Typography>
    {hint && (
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360, textAlign: 'center' }}>
        {hint}
      </Typography>
    )}
    {action}
  </StatePanel>
);
